import { appLinkPath, supportEditorId, supportSanitizer } from '~/utils/support-markdown';

/**
 * The rendering rules of a Suge answer. The streamed text of agent-api has no output filter, so
 * the agent rules of the support thread apply to it: help links and app links of pos-admin only,
 * and no images. utils/support-markdown.ts owns those rules.
 */

/** The support prefix of the id gives the answer the markdown-it rules of the support messages. */
export const chatAnswerEditorId = (turnId: string): string => supportEditorId(`chat-${turnId}`);

export const chatAnswerSanitizer = (adminOrigin: string) =>
  supportSanitizer({ author: 'agent', adminOrigin, mediaOrigin: null, appLinks: true });

/**
 * The app page that a click in an answer opens with the router, or null for the browser default.
 * A modified click keeps the browser behavior, for example a new tab.
 */
export const appLinkOfClick = (event: MouseEvent, adminOrigin: string): string | null => {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return null;
  }
  const link = event.target instanceof Element ? event.target.closest('a') : null;
  return link ? appLinkPath(link.getAttribute('href') ?? '', adminOrigin) : null;
};
